export default String.raw`
<div class="cart-message form-js note-in-order-js form__input-wrapper">
    {% if page.QueryString contains 'inquiry=true' -%}   
        <label for="note" class="form__input-info input-info-js on-inquiry">{{ translations.Notes }}</label>
        <textarea id="note" class="cart-message__note on-inquiry input-value-js" maxlength="500" name="message" {% if page.QueryString contains 'empty-inquiry=true' -%} required {% endif -%}></textarea>
    {% else -%}
        <label for="comment" class="form__input-info input-info-js">{{ translations.Comment }}</label>
        <input type="hidden" name="__action" value="Order/NoteAdd" class="post-js" >      
        <textarea id="comment" class="cart-message__note add-note-js input-value-js" maxlength="500" name="note">{{cart.Note}}</textarea>
    {% endif -%}
    <div class="cart-message__note-counter characters-counter-js hidden-js"></div>
    {% if page.QueryString contains 'empty-inquiry=true' -%}
        <div class="error validation-info-js validation-required-js hidden-js">{{ translations.FillMessageContent }}</div>
    {% endif -%}
</div>

{% if config.Orders.AttachmentsEnabled -%}
    <div>
        <label tabindex="0" role="button" for="file-in-cart" class="cart-message__add-file">
            <svg>
                <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#paperclip-{{settings.iconStyle}}"></use>
            </svg> 
            &nbsp;{{ translations.AddAttachement }}&nbsp;
            <span>({{ translations.CartFileMax | Format: config.Orders.AttachmentsMaxCount }})</span>
        </label>
        <input tabindex="-1" class="add-attachement-in-order-js" id="file-in-cart" type="file" name="file-in-cart" accept="{{ config.Orders.AttachmentExtensions }}" multiple >

        <div class="cart-message__attachements attachements-js">
            {% include 'partials/cart/attachements.html' -%}
        </div>
    </div>
{% endif -%}
`